(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mr-brand-size-chart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mr-size-finder')) {
    customElements.define('mr-size-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.select = this.querySelector('[data-size-select]');
        this.result = this.querySelector('[data-size-result]');
        this.announcement = this.querySelector('[data-size-announcement]');
        this.status = this.querySelector('[data-size-status]');
        if (!this.select || !this.result || !this.announcement) return;
        this.initialized = true;
        this.select.addEventListener('change', () => this.update());
        this.querySelector('.mr-size-chart__finder').hidden = false;
        this.update();
      }
      update() {
        const option = this.select.selectedOptions[0];
        const values = option?.dataset.sizeValues?.split('|');
        const valid = values?.length === 7 && values[0] === this.select.value && values[1];
        this.result.hidden = !valid;
        this.querySelectorAll('[data-size]').forEach(row => {
          const active = Boolean(valid && row.dataset.size === values[0]);
          row.classList.toggle('is-selected', active);
          if (row.tagName === 'DETAILS') row.open = active;
        });
        if (!valid) {
          this.announcement.textContent = '';
          this.status.textContent = '';
          return;
        }
        this.announcement.textContent = this.dataset.resultTemplate
          .replace('[number]', values[0])
          .replace('[letter]', values[1])
          .replace('[name]', option.dataset.letterName);
        this.status.textContent = this.announcement.textContent;
        this.querySelectorAll('[data-measurement-index]').forEach(value => {
          value.textContent = values[Number(value.dataset.measurementIndex) + 2];
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
